export default __webpack_public_path__ + "locales/pl/FilesSettings.json?hash=29c3f7b97d3f224a70ee174606c6b441";